import { Button } from 'antd';
import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.colors.black4};
  padding: 16px;
  background-color: ${({ theme }) => theme.colors.white};
  gap: 16px;
  width: 100%;
`;

export const HeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
  gap: 12px;
`;

export const FlashcardsCountWrapper = styled.div`
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  color: ${({ theme }) => theme.colors.black7};
`;

export const FlashcardActionsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const ActionsButtonsWrapper = styled.div`
  display: flex;
  align-items: left;
  gap: 5px;
  flex-direction: column;
`;

export const StyledButton = styled(Button)`
  color: ${({ theme }) => theme.colors.black9};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  text-align: left;
  border: none;
  box-shadow: none;
  & > * {
    width: 100%;
    text-align: left;
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
  }
`;

export const InfoWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 20px;
  width: 100%;
  cursor: pointer;
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
  flex: 1 0 0;
  height: 100%;
  padding: 4px 0;
`;

export const TitleWrapper = styled.div`
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.black9};
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
`;

export const SubtitleWrapper = styled.div`
  overflow: hidden;
  color: ${({ theme }) => theme.colors.black7};
  text-overflow: ellipsis;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
`;

export const NumberWrapper = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: center;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.black9};
`;

export const PercentageWrapper = styled.div`
  font-size: 11px;
  font-weight: 400;
  line-height: 16px;
`;

export const FooterWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  width: 100%;
`;

export const ActionsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;
